import { render, staticRenderFns } from "./create-chain.vue?vue&type=template&id=ec91d802&scoped=true&"
import script from "./create-chain.vue?vue&type=script&lang=js&"
export * from "./create-chain.vue?vue&type=script&lang=js&"
import style0 from "./create-chain.vue?vue&type=style&index=0&id=ec91d802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec91d802",
  null
  
)

export default component.exports